import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ExportInvoiceCreationDate } from 'src/app/shared/validator/exportInvoiceCreationDate.validator';

@Component({
  selector: 'app-export-invoices-exact-online',
  templateUrl: './export-invoices-exact-online.component.html',
  styleUrls: ['./export-invoices-exact-online.component.css']
})
export class ExportInvoicesExactOnlineComponent implements OnInit {

  @Input() form: UntypedFormGroup;

  constructor() {
  }

  ngOnInit(): void {
    this.form.addControl('invoiceCreationFrom', new UntypedFormControl());
    this.form.addControl('invoiceCreationTo', new UntypedFormControl());
    this.form.addControl('customerId', new UntypedFormControl());
    this.form.addValidators(ExportInvoiceCreationDate.invoiceCreationDateValidator())
  }

  clearInvoiceCreationFrom() {
    this.form.controls.invoiceCreationFrom.setValue('');
  }

  clearInvoiceCreationTo() {
    this.form.controls.invoiceCreationTo.setValue('');
  }
}


